const langFormat: string = "en-NG"

// Some endpoints (e.g. gettaxofficesbycurrency) expect an ISO 4217 currency
// code, but the country <Select>s in our forms carry an ISO 3166-1 alpha-2
// country code (e.g. "GH", not "GHS"). Map the countries where the two
// diverge; callers fall back to the alpha-2 value as-is elsewhere.
export const ALPHA2_TO_CURRENCY_CODE: Record<string, string> = {
  GH: "GHS",
  KE: "KES",
}

export const getCurrencyCodeFromAlpha2 = (alpha2Code?: string | null) => {
  const code = (alpha2Code ?? "").trim().toUpperCase()
  return ALPHA2_TO_CURRENCY_CODE[code] ?? code
}

export const isKenyaCurrency = (currencyCode?: string | null) =>
  (currencyCode ?? "").trim().toUpperCase() === "KES"

export const formatCurrencyNoSymbol = (
  amount: number,
  options?: Intl.NumberFormatOptions
) =>
  new Intl.NumberFormat(langFormat, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    ...options,
  }).format(amount)

// ─── Currency symbol → HTML hex entity ────────────────────────────────────────
// Used to encode currency symbols in offer-letter HTML content so they render
// consistently regardless of source or target encoding.

export const CURRENCY_SYMBOL_HEX: Record<string, string> = {
  "₦": "&#x20A6;", // NGN
  "€": "&#x20AC;", // EUR
  "£": "&#xA3;", // GBP
  "¥": "&#xA5;", // JPY / CNY
  "₹": "&#x20B9;", // INR
  "₩": "&#x20A9;", // KRW
  "₽": "&#x20BD;", // RUB
  R$: "&#x52;&#x24;", // BRL — must be matched before bare "R"
  R: "&#x52;", // ZAR
  $: "&#x24;", // USD / AUD / CAD
}

// Single-symbol → hex (for template substitution)
export const toCurrencyHex = (symbol?: string | null): string => {
  if (!symbol) return ""
  return CURRENCY_SYMBOL_HEX[symbol] ?? symbol
}

// Replace inline currency symbols inside an HTML string with hex entities.
// Ambiguous symbols (R, R$, $) are replaced only when followed by a digit so
// the letter "R" or a stray "$" in prose isn't accidentally encoded.
export const replaceCurrencySymbolsInHtml = (html?: string | null): string => {
  if (!html) return html ?? ""
  return html
    .replace(/R\$(?=\s*\d)/g, "&#x52;&#x24;")
    .replace(/R(?=\s*\d)/g, "&#x52;")
    .replace(/\$(?=\s*\d)/g, "&#x24;")
    .replace(/₦/g, "&#x20A6;")
    .replace(/€/g, "&#x20AC;")
    .replace(/£/g, "&#xA3;")
    .replace(/¥/g, "&#xA5;")
    .replace(/₹/g, "&#x20B9;")
    .replace(/₩/g, "&#x20A9;")
    .replace(/₽/g, "&#x20BD;")
}
